import { render, staticRenderFns } from "./composantInfosDeclaContributeur.vue?vue&type=template&id=1d96ac3a&scoped=true"
import script from "./composantInfosDeclaContributeur.vue?vue&type=script&lang=js"
export * from "./composantInfosDeclaContributeur.vue?vue&type=script&lang=js"
import style0 from "./composantInfosDeclaContributeur.vue?vue&type=style&index=0&id=1d96ac3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d96ac3a",
  null
  
)

export default component.exports